import { render, staticRenderFns } from "./DeptRoleInfo.vue?vue&type=template&id=39313938&scoped=true"
import script from "./DeptRoleInfo.vue?vue&type=script&lang=js"
export * from "./DeptRoleInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39313938",
  null
  
)

export default component.exports